<template>
	<v-list class="pa-0" dense>
		<template v-for="(item, i) in actions">
			<v-divider :key="'div' + i" v-if="!!i" />
			<v-list-tile :key="item.id" :to="routePath(item.id)">
				<v-container fluid class="pa-0">
					<v-layout justify-start align-center>
						<v-flex class="text-truncate mr-2">
							<v-list-tile-title>{{ item.title }}</v-list-tile-title>
						</v-flex>
						<v-spacer />
						<v-flex shrink>
							<action-stats :item="item" />
						</v-flex>
						<v-flex class="text-xs-right hidden-xs-only" style="min-width:100px;max-width:100px">
							<v-list-tile-action-text>{{ item.updatedAt | toRelativeDate }}</v-list-tile-action-text>
						</v-flex>
					</v-layout>
				</v-container>
			</v-list-tile>
		</template>
	</v-list>
</template>


<script>
import { toRelativeDate } from '@/utils/formatters';
import ActionStats from '@/components/ActionStats';

export default {
	name: "action-table",
	components: { ActionStats },
	props: {
		'actions': { type: Array, default: () => [] },
	},
	filters: {
		toRelativeDate,
	},
	methods: {
		routePath(id) {
			const filter = this.$store.getters['actions/currentRouteFilter'];
			return { name: 'action-details', params: { filter, id } };
		},
	},
};
</script>
